export default __webpack_public_path__ + "static/media/linen-texture@3x.17295c21.png";